export enum ErrorMessage {
  InvalidCredentials = "Invalid credentials.",
}
